export default __webpack_public_path__ + "static/media/arrow-back.92f5f911.svg";